export default "__VITE_ASSET__5fddc57e__"